import { InferenceConfig } from "../types/demo";
import { DpInferenceConfig } from "../types/dpInferenceConfig";
import { OcrInferenceConfig } from "../types/ocrInferenceConfig";
import {
  convertDPInferenceConfigToParams,
  convertOcrInferenceConfigToParams,
  DEFAULT_DP_INFERENCE_CONFIG_PARAMS,
  DEFAULT_EXTRACTOR_INFERENCE_CONFIG_PARAMS,
  DEFAULT_OCR_INFERENCE_CONFIG_PARAMS,
} from "../types/request";
import { envVarStore } from "./mobx/EnvVarStore";

export const appendFormDataValues = (
  fd: FormData,
  options: Record<string, any>,
) => {
  return Object.entries(options).forEach(([key, value]) => {
    fd.append(
      key,
      Array.isArray(value) ? JSON.stringify(value) : String(value),
    );
  });
};

export const createInferenceFormData = (
  files: File[],
  url: string,
  type: string,
  serviceName: string,
  endpointType: string,
  inferenceConfig?: InferenceConfig,
) => {
  const fd = new FormData();
  const { noModel } = envVarStore;

  files.map(file => fd.append("document", file));
  fd.append("url", noModel !== "true" ? url : "");
  fd.append("type", type);
  fd.append("serviceName", serviceName);

  if (endpointType === "extractor") {
    appendFormDataValues(fd, DEFAULT_EXTRACTOR_INFERENCE_CONFIG_PARAMS);
  } else if (endpointType === "layout-analysis") {
    const options = inferenceConfig
      ? convertDPInferenceConfigToParams(inferenceConfig as DpInferenceConfig)
      : DEFAULT_DP_INFERENCE_CONFIG_PARAMS;
    appendFormDataValues(fd, options);
  } else if (endpointType === "ocr") {
    const options = inferenceConfig
      ? convertOcrInferenceConfigToParams(inferenceConfig as OcrInferenceConfig)
      : DEFAULT_OCR_INFERENCE_CONFIG_PARAMS;
    appendFormDataValues(fd, options);
  }

  return fd;
};

export const createHeaders = (
  token?: string,
  logEnabled?: boolean,
  sessionId?: string,
  csrfToken?: string,
) => {
  return {
    Authorization: token || "",
    "X-Upstage-Logging-Enabled": logEnabled?.toString() || "true",
    "x-session-id": sessionId || "",
    "x-csrf-token": csrfToken || "",
  };
};
